import { Injectable } from '@angular/core';
import { OrderQuery } from '@modules/order/state/order-query';
import { LabBrokerConfig } from '../state/lab-broker.model';
import { LabSettings, SendToOption } from '@shared/models/send-to-option';

@Injectable({ providedIn: 'root' })
export class LabBrokerConfigService {
	constructor(private readonly orderQuery: OrderQuery) {}

	getConfig(): LabBrokerConfig | null {
		const sendTo = this.orderQuery.sendTo;

		if (!sendTo || !('Settings' in sendTo)) {
			return null;
		}

		const integration = (sendTo as SendToOption & { Settings?: LabSettings }).Settings?.customRxIntegration;

		if (!integration?.customRxUrl?.trim()) {
			return null;
		}

		const labCompanyId = Number((sendTo as { Id: unknown }).Id);

		if (!Number.isFinite(labCompanyId) || labCompanyId <= 0) {
			return null;
		}

		return {
			iframeUrl: integration.customRxUrl,
			integratorName: integration.ui?.continueToNameText ?? 'Lab',
			partnerName: integration.ui?.continueToNameText?.trim() || sendTo.Name,
			rxTemplate: integration.rxTemplate ?? '',
			labCompanyId
		};
	}
}
